import { render } from "./AccountPanel.vue?vue&type=template&id=a4b6ea32&scoped=true"
import script from "./AccountPanel.vue?vue&type=script&lang=js"
export * from "./AccountPanel.vue?vue&type=script&lang=js"

import "./AccountPanel.vue?vue&type=style&index=0&id=a4b6ea32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4b6ea32"]])

export default __exports__